const GUIDE_SECTIONS = [
  {
    title: "Visa & Immigration",
    items: ["Visa types & requirements", "Savings/income thresholds", "Path to residency"],
  },
  {
    title: "Cost of Living",
    items: ["Housing costs by area", "Monthly budget breakdown", "Healthcare expenses"],
  },
  {
    title: "Your Lifestyle",
    items: ["Local clubs & venues", "Expat community info", "Day in the Life video"],
  },
  {
    title: "Practical Guides",
    items: ["Real estate laws", "Tax information", "Banking & internet"],
  },
];

export const GuideContents = () => (
  <div className="bg-card rounded-2xl border border-primary/10 p-8">
    <h2 className="text-2xl font-bold text-primary mb-4">What's in Each Guide?</h2>
    <div className="grid md:grid-cols-4 gap-6">
      {GUIDE_SECTIONS.map((section) => (
        <div key={section.title}>
          <h3 className="font-semibold text-primary mb-2">{section.title}</h3>
          <ul className="space-y-1">
            {section.items.map((item) => (
              <li
                key={item}
                className="text-sm text-muted-foreground flex items-center gap-2"
              >
                <span className="w-1.5 h-1.5 bg-secondary rounded-full" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </div>
);

export default GuideContents;
